<template>
    <div>
        <template v-if="$isMobile()">
            <app-image
                :url="
                    baseurl +
                        '/?l=svg/png&size=mobile&lang=' +
                        lang +
                        '&format=file.png'
                "
                :is-local="false"
                alt="Linea de tiempo precio"
                class="w-full md:mb-6"
                :tryWebp="false"
            >
            </app-image>

            <app-image
                :url="
                    require('../assets/animations/panchito_waving_fallback-min.png')
                "
                :is-local="false"
                alt="Linea de tiempo precio"
                class="m-auto"
                style="position: relative;top: -50px;margin-bottom: -50px;"
                width="150"
                :tryWebp="false"
            >
            </app-image>
        </template>

        <template v-else>
            <SpriteAnim
                id="panchitoWaving"
                :json="require('../assets/animations/panchito_waving-min.json')"
                :png="require('../assets/animations/panchito_waving-min.png')"
                :fps="24"
            />

            <app-image
                :url="
                    baseurl +
                        '/?l=svg/png&size=desktop&lang=' +
                        lang +
                        '&format=file.png'
                "
                :is-local="false"
                :tryWebp="false"
                alt="Linea de tiempo precio"
                class="w-full max-w-screen-lg mx-auto mb-6"
            >
            </app-image>
        </template>
    </div>
</template>

<script>
import { mapState } from "vuex";
import SpriteAnim from "./SpriteAnim";
export default {
    name: "timeline",
    components: {
        SpriteAnim
    },
    data() {
        return {
            baseurl: process.env.VUE_APP_API_URL
        };
    },
    computed: {
        ...mapState(["lang"])
    }
};
</script>
<style>
#panchitoWaving {
    width: 250px;
    height: 250px;
    position: absolute;
    margin-left: 320px;
    margin-top: 50px;
}
#panchitoWaving canvas {
    width: 250px;
    height: 250px;
}
</style>
